import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NzIconModule } from 'ng-zorro-antd/icon';

/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';

//Routing Module for the specific View Module
import { IntimationRoutingModule } from './intimation-routing.module'
import { SearchIntimationComponent } from './search-intimation/search-intimation.component';


//Shared Module
import { SharedComponentsModule } from '../../shared-components/shared-components.module'
import { SharedServicesModule } from '../../shared-services/shared-services.module'

//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services'
import { from } from 'rxjs';
import { NgZorroAntdModule } from 'app/ng-zorro.module';

const _components = [SearchIntimationComponent]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgZorroAntdModule,
    NzIconModule,
    SharedComponentsModule,
    SharedServicesModule,
    IntimationRoutingModule,
  ],
  declarations: [..._components],
  exports: [..._components]
})
export class IntimationModule {
  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService: MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }
}
